import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import type { ResourceRequestType } from 'api/resource-request/types';
import { useTranslate } from 'hooks/use-translation';

interface ResoruceRequestCreateMessageProps {
  causerName: string;
  requestType: string;
  keyForString: string;
}
export const ResoruceRequestCreateMessage: FC<ResoruceRequestCreateMessageProps> =
  ({ causerName = '', keyForString = '', requestType = '' }) => {
    const translate = useTranslate();

    const requestTypeLocale = translate(
      `apps.resource_request.${requestType as ResourceRequestType}.title`,
    );

    return (
      <FormattedMessage
        id={keyForString}
        values={{
          changedByUserName: causerName ?? '',
          resourceRequestType: requestTypeLocale ?? '',
        }}
      />
    );
  };
